type PropTypes = {
  className?: string
}

const ChevronIcon = ({ className }: PropTypes) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 10 6"
      className={className}
    >
      <path
        fill="currentColor"
        d="M5 6 0 1 .7.3 5 4.6 9.3.3l.7.7-5 5Z"
      />
    </svg>
  )
}

export default ChevronIcon
